export const newLineToHTMLBR = (text: string): string => {
  return text.replace(/\n/g, '<br />')
}
